import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as StaffEnquiryActions from "../../Actions/StaffEnquiry";
import * as sharedActions from "../../Actions/sharedActions";
import SnackBar from "../../components/SnackBar/SnackBar";
import $ from "jquery";
import StaffTableComponent from "./StaffTableComponent";
import ThemeContext from "../../context/themeContext/ThemeContext";

class ViewStaffEnquiryPagination extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classId: "",
      adminData: [],
      modalData: null,
      vehicleNo: "",
      capacity: "",
      transportType: "",
      enabled: false,
      id: null,
      select: [],
      routeId: "",
      routeName: "",
      startingServiceKm: "",
      midServiceKm: "",
      endingServiceKm: "",
      vehicleDateOfReg: "",
      vehicleDateOfRegExpiry: "",
      isLoading: true,
      disablepage: false,
      disableBPage: true,
      currentPage: 1,
      todosPerPage: 10,
      pageCounter: 10,
      msg: "",
      increament: 1,
      classSelect: "",
      btnLoad: false,
      checking: [],
    };
  }
  handleClickNextFrwd = () => {
    const { adminData, todosPerPage, count, currentPage } = this.state;
    let pageNumbers = [];
    for (
      let i = 1;
      i <= Math.ceil(adminData.length / this.state.todosPerPage);
      i++
    ) {
      pageNumbers.push(i);
    }
    console.log("pagelength: ", pageNumbers.length);
    console.log("current page: ", currentPage);
    if (currentPage === pageNumbers.length) {
      this.setState({
        disablepage: true,
      });
    } else {
      this.setState((prevState) => ({
        currentPage: prevState.currentPage + 1,
        disableBPage: false,
      }));
    }
  };
  onSelectChange = (e) => {
    console.log(e.target.value);
    let result = e.target.value;
    console.log(result);
    this.setState({
      classId: result,
    });
  };
  handleClickNextBack = () => {
    const { adminData, todosPerPage, count, currentPage } = this.state;
    console.log("current page: ", currentPage);
    if (currentPage === 1) {
      this.setState({
        disableBPage: true,
        disablepage: false,
      });
    } else {
      this.setState((prevState) => ({
        currentPage: prevState.currentPage - 1,
      }));
      this.setState({
        disablepage: false,
      });
    }
  };
  handleClickNext = (event) => {
    this.setState({
      currentPage: Number(event.target.id),
      disablepage: false,
      disableBPage: false,
    });
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      prevState.adminData !== nextProps.AllTransportData ||
      prevState.classSelect !== nextProps.selectData
    ) {
      return {
        adminData: nextProps.AllTransportData,
        classSelect: nextProps.selectData,
      };
    }
    return null;
  }
  componentDidUpdate() {
    $('[data-toggle="tooltip"]').tooltip();
  }
  componentDidMount() {
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.props.sharedActions
      .gAllData(
        "/api/ClassSection",
        this.props.StaffEnquiryActions.getClassesForStaffEnquirySearch
      )
      .then((success) => {
        console.log(success);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  SearchStaff = (e) => {
    this.setState({
      btnLoad: true,
    });
    this.props.sharedActions
      .getAllData(
        `/api/StaffEnquiryForm?classId=${this.state.classId}&pageNumber=1&pageSize=10`,
        this.props.StaffEnquiryActions.setAllStaffEnquiryInRedux,
        this.props.StaffEnquiryActions.updateStaffEnquiryFlag
      )
      .then((success) => {
        debugger;
        this.setState({
          isLoading: false,
          btnLoad: false,
          checking: this.state.adminData.paginationMetadata,
        });
      })
      .catch((err) => {
        this.props.StaffEnquiryActions.updateStaffEnquiryFlag(false);
        debugger;
        this.setState({
          adminData: [],
          isLoading: false,
          btnLoad: false,
        });

        console.log(err);
      });
  };
  btnTechHover = () => {
    $(document).ready(function () {
      $("button").hover(
        function () {
          $(this).css("box-shadow", "0px 5px 5px grey");
          $(this).css("border-color", "white");
        },
        function () {
          $(this).css("box-shadow", "0px 0px 0px white");
        }
      );
    });
  };
  onTakeItem = (itemId) => {
    this.setState({
      modalData: [],
    });
    const { adminData } = this.state;
    let getData = adminData.filter((item) => item.id === itemId);

    this.setState({
      modalData: getData,
      transportType: getData[0].transportType,
      capacity: getData[0].capacity,
      vehicleNo: getData[0].vehicleNo,
      id: getData[0].id,
      routeName: getData[0].dropOff,
      routeId: getData[0].routeId,
      startingServiceKm: getData[0].startingServiceKm,
      midServiceKm: getData[0].midServiceKm,
      endingServiceKm: getData[0].endingServiceKm,
      vehicleDateOfReg: getData[0].vehicleDateOfReg,
      vehicleDateOfRegExpiry: getData[0].vehicleDateOfRegExpiry,
    });
  };

  onHandleText = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  onEditClick = (itemId) => {
    this.onTakeItem(itemId);
    this.setState({ enabled: false });
  };
  myFunction = () => {
    // Get the snackbar DIV
    var x = document.getElementById("snackbar");

    // StepperGeneralButtons the "show" class to DIV
    x.className = "show";

    // After 3 seconds, remove the show class from DIV
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 3000);
  };
  paginationRequest = (number) => {
    this.props.sharedActions
      .getAllData(
        `/api/StaffEnquiryForm?classId=${this.state.classId}&pageNumber=${number}&pageSize=10`,
        this.props.StaffEnquiryActions.setAllStaffEnquiryInRedux,
        this.props.StaffEnquiryActions.updateStaffEnquiryFlag
      )
      .then((success) => {
        this.setState({
          isLoading: false,
        });
      })
      .catch((err) => {
        this.props.StaffEnquiryActions.updateStaffEnquiryFlag(false);

        this.setState({
          isLoading: false,
        });

        console.log(err);
      });
  };
  render() {
    const { adminData, modalData, select, classId } = this.state;
    console.log("Admin Data", this.state.adminData);
    const { staffEnquiry } = this.state.adminData;
    console.log("Staff Ka Data", staffEnquiry);
    const { classList } = this.state.classSelect;
    console.log("Classes Ka Data", classList);

    console.log("modal data: ", this.state.modalData);
    const Loader = (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <label style={{ color: "red" }}>No Data</label>
      </div>
    );
    let pageNumbers = [];
    for (
      let i = 1;
      i <=
      Math.ceil(this.state.checking.totalCount / this.state.checking.pageSize);
      i++
    ) {
      pageNumbers.push(i);
    }
    const renderPageNumbers = pageNumbers.map((number, index) => {
      return (
        <li
          class={`page-item ${
            this.state.checking.currentPage === number ? "active" : ""
          } `}
        >
          <a
            key={number}
            id={number}
            onClick={() => this.paginationRequest(number)}
            class="page-link "
            href="#"
          >
            {number}
          </a>
        </li>
      );
    });
    const MainContent = (
      <div>
        <div class="modal" id="myModal1">
          <div class="modal-dialog">
            <div class="modal-content modal_content_custom">
              <div
                style={{
                  borderBottomLeftRadius: 30,
                  borderBottomRightRadius: 30,
                  borderTopLeftRadius: 18,
                  borderTopRightRadius: 18,
                }}
                class="modal-header modal_custom_header"
              >
                <h4 style={{ color: "white" }} class="modal-title">
                  Confirm
                </h4>
                <button
                  style={{ color: "white" }}
                  type="button"
                  class="close"
                  data-dismiss="modal"
                >
                  &times;
                </button>
              </div>
              <div class="modal-body">
                {modalData &&
                  modalData.map((item, index) => (
                    <div key={index}>
                      <div style={{ textAlign: "center" }}>
                        <h4>Are you sure ?</h4>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <div>
                          <button
                            disabled={this.state.enabled}
                            data-dismiss="modal"
                            onClick={() => this.onTakeItemDelete(this.state.id)}
                            type="button"
                            class="btn btn-primary buttonAppear"
                          >
                            Yes
                          </button>
                        </div>
                        <div>
                          <button
                            data-dismiss="modal"
                            disabled={this.state.enabled}
                            type="button"
                            class="btn btn-primary buttonAppear"
                          >
                            No
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
        <div class="modal" id="myModal">
          <div class="modal-dialog">
            <div class="modal-content modal_content_custom">
              <div
                style={{
                  borderBottomLeftRadius: 30,
                  borderBottomRightRadius: 30,
                  borderTopLeftRadius: 18,
                  borderTopRightRadius: 18,
                }}
                class="modal-header modal_custom_header"
              >
                <h4 style={{ color: "white" }} class="modal-title">
                  Details
                </h4>
                <button
                  style={{ color: "white" }}
                  type="button"
                  class="close"
                  data-dismiss="modal"
                >
                  &times;
                </button>
              </div>
              <div class="modal-body">
                <form onSubmit={this.onHandleSubmit}>
                  {modalData &&
                    modalData.map((item, index) => (
                      <div key={index}>
                        <fieldset disabled={!this.state.enabled}>
                          <div class="form-group">
                            <label for="transportType">Transport Type:</label>
                            <input
                              style={{
                                borderTop: 0,
                                borderLeft: 0,
                                borderRight: 0,
                                boxShadow: "none",
                              }}
                              type="text"
                              value={this.state.transportType}
                              onChange={this.onHandleText}
                              name="transportType"
                              class="form-control"
                              id="transportType"
                            />
                          </div>
                          <div class="form-group">
                            <label for="capacity">Capacity</label>
                            <input
                              required
                              style={{
                                borderTop: 0,
                                borderLeft: 0,
                                borderRight: 0,
                                boxShadow: "none",
                              }}
                              value={this.state.capacity}
                              onChange={this.onHandleText}
                              type="text"
                              name="capacity"
                              class="form-control"
                              id="capacity"
                            />
                          </div>
                          <div class="form-group">
                            <label for="vehicleNo">Vehicle Registration</label>
                            <input
                              required
                              style={{
                                borderTop: 0,
                                borderLeft: 0,
                                borderRight: 0,
                                boxShadow: "none",
                              }}
                              value={this.state.vehicleNo}
                              onChange={this.onHandleText}
                              type="text"
                              name="vehicleNo"
                              class="form-control"
                              id="vehicleNo"
                            />
                          </div>
                          <div class="form-group">
                            <label for="vehicleNo">Starting Service KM</label>
                            <input
                              required
                              style={{
                                borderTop: 0,
                                borderLeft: 0,
                                borderRight: 0,
                                boxShadow: "none",
                              }}
                              value={this.state.startingServiceKm}
                              onChange={this.onHandleText}
                              type="text"
                              name="startingServiceKm"
                              class="form-control"
                              id="startingServiceKm"
                            />
                          </div>
                          <div class="form-group">
                            <label for="vehicleNo">Mid Service KM</label>
                            <input
                              required
                              style={{
                                borderTop: 0,
                                borderLeft: 0,
                                borderRight: 0,
                                boxShadow: "none",
                              }}
                              value={this.state.midServiceKm}
                              onChange={this.onHandleText}
                              type="text"
                              name="midServiceKm"
                              class="form-control"
                              id="midServiceKm"
                            />
                          </div>
                          <div class="form-group">
                            <label for="vehicleNo">Ending Service KM</label>
                            <input
                              required
                              style={{
                                borderTop: 0,
                                borderLeft: 0,
                                borderRight: 0,
                                boxShadow: "none",
                              }}
                              value={this.state.endingServiceKm}
                              onChange={this.onHandleText}
                              type="text"
                              name="endingServiceKm"
                              class="form-control"
                              id="endingServiceKm"
                            />
                          </div>
                          <div class="form-group">
                            <label for="canteenName">Route Name:</label>
                            <input
                              readOnly={true}
                              style={{
                                borderTop: 0,
                                borderLeft: 0,
                                borderRight: 0,
                                boxShadow: "none",
                              }}
                              type="text"
                              value={this.state.routeName}
                              onChange={this.onHandleText}
                              name="routeName"
                              class="form-control"
                              id="routeName"
                            />
                          </div>
                          <div class="col-md-12">
                            <div class="md-form mb-0">
                              <label for="email" class="">
                                <i
                                  style={{ marginRight: 4 }}
                                  className="fas fa-university animated fadeIn"
                                />
                                Route Name
                              </label>
                              <select
                                onChange={this.onSelectChange}
                                class="custom-select"
                                name="select"
                              >
                                <option
                                  selected={this.state.msg ? true : false}
                                >
                                  Choose Root...
                                </option>
                                {select.map((item, index) => (
                                  <option
                                    key={index}
                                    value={`${JSON.stringify(item)}`}
                                  >
                                    {item.dropOff}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </fieldset>
                        <br />
                        <br />
                        <button
                          disabled={this.state.enabled}
                          onClick={() => this.setState({ enabled: true })}
                          type="button"
                          class="btn btn-primary buttonAppear"
                        >
                          Edit
                        </button>
                        <button
                          style={{ marginLeft: 5 }}
                          disabled={!this.state.enabled}
                          type="submit"
                          class="btn btn-primary buttonAppear"
                        >
                          Save
                        </button>
                      </div>
                    ))}
                </form>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  style={{ background: "#00435D" }}
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <ThemeContext.Consumer>
            {(context) => (
              <table class="table table-hover table-bordered">
                <thead
                  style={{
                    background: context.themeColors.primaryColor,
                    color: "white",
                  }}
                >
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Applicant Name</th>
                    <th scope="col">Class Name</th>
                    <th scope="col">Post Name</th>
                    <th scope="col">Department Name</th>
                    <th scope="col">Status</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <StaffTableComponent data={staffEnquiry} />
                </tbody>
              </table>
            )}
          </ThemeContext.Consumer>
        </div>
      </div>
    );
    return (
      <div>
        <div className="page-header">
          <SnackBar msg={this.state.msg} />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h2>
                Staff Registrations
              </h2>
            </div>
            <nav aria-label="Page navigation example">
              <ul style={{ color: "#01AC8A" }} class="pagination">
                {renderPageNumbers}
              </ul>
            </nav>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-6">
            <div class="md-form mb-0">
              <label for="email" class="">
                <i
                  style={{ marginRight: 4 }}
                  className="fas fa-door-open animated fadeIn"
                />
                Class Name
              </label>
              <select
                onChange={this.onSelectChange}
                class="custom-select"
                name="className"
              >
                <option selected={this.state.msg ? true : false}>
                  Choose Class...
                </option>
                {classList &&
                  classList.map((item, index) => (
                    <option key={index} value={`${item.className}`}>
                      {item.className}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div class="col-md-6" style={{ marginTop: 20, float: "right" }}>
            <div class="md-form mb-0">
              <ThemeContext.Consumer>
                {(context) => (
                  <button
                    className="mt-3"
                    type="submit"
                    disabled={classId !== "" ? false : true}
                    style={{
                      backgroundColor:
                        classId !== ""
                          ? context.themeColors.primaryColor
                          : "#ABD0BC",
                      border: "none",
                      fontSize: 20,
                      borderRadius: 4,
                      color: "white",
                    }}
                    onClick={this.SearchStaff}
                  >
                    Search
                    <i
                      style={{ color: "white", marginLeft: 4 }}
                      class="fas fa-search"
                    ></i>
                    <span
                      style={{ marginBottom: 5 }}
                      class={`${
                        this.state.btnLoad
                          ? "spinner-border spinner-border-sm"
                          : ""
                      }`}
                    ></span>
                  </button>
                )}
              </ThemeContext.Consumer>
            </div>
          </div>
        </div>
        <br />
        <br />
        {this.props.allTransportState.apiFlag ? Loader : MainContent}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    StaffEnquiryActions: bindActionCreators(StaffEnquiryActions, dispatch),
    sharedActions: bindActionCreators(sharedActions, dispatch),
  };
}
function mapStateToProps(state) {
  return {
    AllTransportData: state.setStaffEnquiryReducer.Data,
    allTransportState: state.setStaffEnquiryReducer,
    selectData: state.setStaffEnquiryReducer.selectClass,
    users: state.setUserReducer.users,
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewStaffEnquiryPagination);
